import { V3Record } from "data/helpers/V3Record.js";

export const AmbassadorRoute = V3Record("ambassadorRoute", {
  id: null,
  routeId: null,
  ambassadorId: null,
  detailedDescription: null,
  subtitle: null,
  ambassadorLogo: null, // string
});
